import React from "react";
import DSDModuleSubtopic from "../DSDModuleSubtopic";

const ProgrammableLogicDevicesModule = () => (
  <DSDModuleSubtopic
    title="Programmable Logic Devices: PLA, PAL, CPLD, FPGA"
    videos={[
      "https://www.youtube.com/embed/7PQwJQb6OkE",
      "https://www.youtube.com/embed/S3acjenGqwE",
      "https://www.youtube.com/embed/2W3UybKjcU0",
      "https://www.youtube.com/embed/K3FBDL7xETc",
      "https://www.youtube.com/embed/RNLtpp2ZHbE"
    ]}
    takeaways={[]}
    questions={[
      {
        text: "The logic circuit shown below has three inputs X, Y, and Z and two outputs F and G. Implement the given circuit using a PLA.",
        image:"/dsd_25.png"
      },
      {
        text: `Implement the following Boolean functions using 4 x 3 x 4 PAL:
(i) W(A,B,C,D) = Σ(0,2,6,7,8,9,12,13)
(ii) X(A,B,C,D) = Σ(0,2,6,7,8,9,12,13,14)
(iii) Y(A,B,C,D) = Σ(2,3,8,9,10,12,13)
(iv) Z(A,B,C,D) = Σ(1,3,4,6,9,12,14)`
      },
      {
        text: "Detail the FPGA design flow."
      },
      {
        text: "Compare and contrast the architectures of PAL, PLA, and FPGA with neat diagrams."
      },
      {
        text: "Discuss various applications of Programmable Logic Devices (PLDs)."
      }
    ]}
    exampleVideos={[]}
  />
);

export default ProgrammableLogicDevicesModule;
